import type { CreateNewsDto, ListDto } from "@/entities/types/entities";

export const getPostSlug = (post?: CreateNewsDto) =>
    post?.editor?.slug || post?.urlTitle || (post?.id ? `post-${post.id}` : "");

export const getPostExcerpt = (post?: CreateNewsDto) => post?.editor?.excerpt || post?.subtitle || "";

export const getPostBodyHtml = (post?: CreateNewsDto) => post?.editor?.bodyHtml || post?.contentItems?.[0]?.text || "";

export const getPostOutline = (post?: CreateNewsDto): ListDto[] =>
    post?.editor?.blocks
        ?.filter((block) => block.type === "list" && block.list)
        .map((block) => block.list as ListDto) || post?.list || [];
